import React from 'react'

import DotsSvg from '@/assets/img/dots.svg'
import Dropdown from '@/compoments/common/Dropdown'
import UserPart from '@/compoments/common/UserPart'
import DropdownList from '@/compoments/DropdownList'
import type { CustomerFeedbacks } from '@/types/executives'
const Table = ({ data }: { data?: CustomerFeedbacks[] }) => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Customer</th>
                    <th>Order</th>
                    <th style={{ width: '100%' }}>Feedback</th>
                    <th>Rate</th>
                    <th>Technician</th>
                    <th style={{ width: 10 }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {data && data?.length > 0 ? (
                    data.map((feedback, index) => (
                        <tr key={index}>
                            <td>
                                <UserPart
                                    src={feedback.customer.photo}
                                    email={feedback.customer.email}
                                    name={feedback.customer.fullName}
                                />
                            </td>
                            <td>
                                <span className="text--xs">
                                    {feedback.order.id}
                                </span>
                            </td>
                            <td className="text-wrap">
                                <span className="text--xs color-text-color-1">
                                    {feedback.comment}
                                </span>
                            </td>
                            <td>
                                <span className="fw-600 text--xs color-primary">
                                    {feedback.rating}
                                </span>
                            </td>
                            <td>
                                <UserPart
                                    src={feedback.technician.photo}
                                    email={feedback.technician.fullName}
                                    name={feedback.technician.email}
                                />
                            </td>
                            <td className="text-right sticky-end">
                                <Dropdown
                                    closeSelf={true}
                                    dropdownClasses="flex flex-col"
                                    button={
                                        <span className="ico">
                                            <img src={DotsSvg} alt="" />
                                        </span>
                                    }
                                    menuClassName="dropdown-md"
                                    menu={<DropdownList list={[]} />}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={5}>
                            <h4 className="text-center">Feedbacks not found</h4>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export default Table
